import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, NavigationEnd } from '@angular/router';
import { AlertsService } from '../../services/alerts/alerts.service';
import { BaseComponent } from '../base/base.component';
import { ButtonComponent } from '../core/buttons/button.component';
import { PageHeaderComponent } from '../core/labels/page-header.component';
import { TabPanelComponent } from '../core/panels/tab-panel/tab-panel.component';
import { TabComponent } from '../core/panels/tab-panel/tab.component';
import { AlertsListComponent } from './alerts-list.component';
import { AlertsMessagesComponent } from './alerts-messages.component';
import { HomeCardComponent } from '../home/home-card.component';

@Component({
  selector: 'app-alerts-landing',
  imports: [
    TabPanelComponent,
    TabComponent,
    AlertsMessagesComponent,
    AlertsListComponent,
    PageHeaderComponent,
    ButtonComponent,
    HomeCardComponent,
  ],
  template: `
    <app-page-header label="Alerts" headerSize="h1">
      <ng-template #right>
        <app-button label="New alert" (click)="newAlert()" />
      </ng-template>
    </app-page-header>
    <div class="tw-grow tw-w-full tw-justify-center">
      <app-home-card type="Large">
        <div class="tw-pb-8 tw-w-full tw-min-w-0">
          <app-tab-panel
            [value]="tab"
            activeTabQueryParam="tab"
            (valueChange)="onChange($event)"
          >
            <app-tab label="Alert Messages" value="messages">
              <ng-template #content>
                <app-alerts-messages />
              </ng-template>
            </app-tab>
            <app-tab label="Manage Alerts" value="my-alerts">
              <ng-template #content> <app-alerts-list /> </ng-template>
            </app-tab>
          </app-tab-panel>
        </div>
      </app-home-card>
    </div>
  `,
  styles: ``,
})
export class AlertsLandingComponent extends BaseComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private alerts = inject(AlertsService);

  tab = 'messages';

  onChange(event: any) {
    this.tab = event;
  }

  async ngOnInit(): Promise<void> {
    this.setTabFromRoute();
    this.syncDefaultTabToQueryString();
    this.dispose.subs = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url.startsWith('/alerts')) {
          this.setTabFromRoute();
          this.syncDefaultTabToQueryString();
        }
      }
    });
  }

  newAlert() {
    this.alerts.createNewAlert();
    this.router.navigate(['alerts/edit-alert']);
  }

  setTabFromRoute() {
    const tabParam = this.route.snapshot.queryParamMap.get('tab');
    // this code was defaulting to messages. This causes issues
    // with breadcrumbs back to view screen.
    if (tabParam) {
      this.tab = tabParam;
    }
  }

  private syncDefaultTabToQueryString(): void {
    if (this.route.snapshot.queryParamMap.has('tab')) return;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { tab: this.tab },
      queryParamsHandling: 'merge',
      replaceUrl: true,
    });
  }
}
